import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";

@Injectable()
export class DateInterceptor implements HttpInterceptor {
    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(req).pipe(
            map(event => {
                if (event instanceof HttpResponse && typeof event.body === 'object') {
                    return event.clone({ body: this.convertDates(event.body) });
                }
                return event;
            })
        );
    }

    private convertDates(obj: unknown): unknown {
        if (!obj || (typeof obj !== 'object' && typeof obj !== 'string')) return obj;
        
        // Handle string case first
        if (typeof obj === 'string') {
            const isoLike = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z?$/;
            if (isoLike.test(obj)) {
                return new Date(obj);
            }
            return obj;
        }

        // Handle arrays
        if (Array.isArray(obj)) {
            return obj.map(item => this.convertDates(item));
        }

        // Handle objects
        const objRecord = obj as Record<string, unknown>;
        const result = { ...objRecord }; // Create a copy to avoid mutation
        for (const key of Object.keys(result)) {
            result[key] = this.convertDates(result[key]);
        }
        return result;
    }
}